<messages>["./SimpleShiftDialog"]</messages>

<template>
  <confirmation-dialog
    v-model="showDialog"
    :headline="$t (`title.${type}`)"
    :error-msg="errorMsg"
    :is-loading="isLoading"
    @ok="request">
    <v-row>
      <v-col cols="12">
        <p v-text="$t (`intro.${type}`, {name: shiftObject.name})"/>
        <client-select
          v-model="internalClientId"
          @loading="onClientsLoading"
          @loaded="onClientsLoaded"/>
      </v-col>
      <v-col v-if="response" cols="12">
        <v-btn text color="error" @click="showDetails = !showDetails">
          {{ $t(`general.label.${showDetails ? 'hideErrorDetails' : 'showErrorDetails'}`) }}
        </v-btn>
      </v-col>
      <v-col v-if="response && showDetails" cols="12">
        <order-processing-response :response="response" :show-card-border="false" hide-title/>
      </v-col>
    </v-row>
  </confirmation-dialog>
</template>

<script>
  import {mapMutations, mapActions} from 'vuex'

  import ConfirmationDialog from '@/app/core/components/ConfirmationDialog'
  import ClientSelect from '@/app/core/components/ClientSelect'

  import OrderProcessingResponse
    from '@/app/core/components/RegistryObject/OrderProcessingResponse'

  export default {
    name: 'ShiftDialog',

    components: {
      ConfirmationDialog,
      ClientSelect,
      OrderProcessingResponse
    },

    props: {
      shiftObject: {
        type: Object,
        required: true,
        validator (value) {
          return ['id', 'name'].every ((key) => {
            return value[key] !== undefined
          })
        }
      },
      value: {
        type: Boolean,
        required: true
      },
      type: {
        type: String,
        required: true,
        validator (val) {
          return ['contact', 'zone', 'host'].includes (val)
        }
      }
    },

    data () {
      return {
        isLoading: false,
        errorMsg: '',
        internalClientId: 0,
        availableClients: [],
        loadingClients: false,
        response: null,
        showDetails: false
      }
    },

    computed: {
      showDialog: {
        get () {
          return this.value
        },

        set (newValue) {
          this.$emit ('input', newValue)
        }
      }
    },

    watch: {
      clientId (newValue) {
        this.internalClientId = newValue || this.preSelectOwnClient ()
      },
      value (newValue) {
        if (!newValue) {
          this.errorMsg = ''
        }
      },
      showDialog (newValue) {
        if (!newValue) {
          this.response = null
          this.errorMsg = ''
          this.internalClientId = 0
          this.showDetails = false
        }
      }
    },

    methods: {
      ...mapMutations ('notification', ['addEvent']),
      ...mapMutations ({
        displaySuccessMessage: 'notification/setSuccess'
      }),

      ...mapActions ({
        fetchData: 'request/fetchData'
      }),

      request () {
        this.isLoading = true
        this.response = null

        this.fetchData ({
          op: `${this.type}/shift`,
          params: {
            id: this.shiftObject.id,
            clientId: this.internalClientId
          },
          cb: data => {
            this.isLoading = false
            this.displaySuccessMessage (this.$t (`success.${this.type}`,
                                                 {client: this.internalClientId, name: this.shiftObject.name}))

            this.addEvent ({
              type: 'success',
              message: this.$t (`success.${this.type}`, {client: this.internalClientId, name: this.shiftObject.name}),
              objects: [{name: this.shiftObject.name, link: {name: `${this.type}.view.id`, params: {id: this.shiftObject.id}}}]
            })

            this.$emit ('shifted')
            this.errorMsg = ''
            this.showDialog = false
          },
          cbError: data => {
            if (data.errors ? data.errors.length > 0 : false) {
              this.errorMsg = data.errors[0].message

              this.response = data.errors
            } else {
              this.errorMsg = this.$t ('error')
            }
          },
          cbFinal: () => {
            this.isLoading = false
          }
        })
      },

      /**
       * Show progress bar when clients are being loaded.
       */
      onClientsLoading () {
        this.loadingClients = true
      },

      /**
       * Stop showing progress bar when clients have been loaded
       */
      onClientsLoaded (clients) {
        this.loadingClients = false
        this.availableClients = clients
      }
    }
  }
</script>
